import { DetailValue } from 'components/common'
import { getDetailUrl } from 'models/ParkingCard/api'


const ParkingCardValue = ({ detail, asLink, isBack }) => {
  return (
    <DetailValue
      url={asLink && getDetailUrl(detail)}
      isBack={isBack}
      className="flex"
      render={() => (
        <>
          {detail?.rpsCard_id || '-'}
        </>
      )}
    />
  );
};


export default ParkingCardValue
